module.exports = __webpack_public_path__ + "media/customizations/bedfordlife/logo-new-d2c31180c720d8217663572d12e0d0a6.png";